export const SECTION_ID_BLOG = 1;
export const SECTION_ID_CPC = 2;
export const SECTION_ID_ATTACK_CATALOG = 5;
export const SECTION_ID_TRUE_IMAGE = 6;
export const CATEGORY_SLUG_NEWS = 'news';

export const BLOG_SETTINGS_SLICE = 'blog';
export const BLOG_SETTINGS_SLICE_TRUE_IMAGE = 'blog-true-image';
export const MAIN_BLOG_SECTION_IDS = [SECTION_ID_BLOG, SECTION_ID_CPC, SECTION_ID_ATTACK_CATALOG];

export const SECTION_ID_BY_SLUG = {
    blog: SECTION_ID_BLOG,
    tru: SECTION_ID_CPC,
    attack: SECTION_ID_ATTACK_CATALOG,
};

export const SECTION_SLUG_BY_ID = {
    ...Object.fromEntries(Object.entries(SECTION_ID_BY_SLUG).map((x) => x.reverse())),
    [SECTION_ID_TRUE_IMAGE]: 'blog',
};

export const CARD_FIELDS_SUBSET = [
    'id',
    'slug',
    'image_id',
    'section_id',
    'title',
    'description',
    'published_at',
    'time_to_read',
    'tags',
    'categories',
    'author',
    'editors',
];

export const NEWS_NUMBER_ON_PAGE = 4;
